<template>
  <!-- begin:: Aside -->
  <div
    class="aside aside-left aside-fixed d-flex flex-column flex-row-auto border-right"
    id="kt_aside"
    ref="kt_aside"
    @mouseover="mouseEnter"
    @mouseleave="mouseLeave"
  >
    <!-- begin:: Aside -->
    <!-- <KTBrand></KTBrand> -->
    <!-- end:: Aside -->

    <!-- begin:: Aside Menu -->
    <div
      class="aside-menu-wrapper flex-column-fluid"
      id="kt_aside_menu_wrapper"
    >
      <div
        ref="kt_aside_menu"
        id="kt_aside_menu"
        class="aside-menu"
        data-menu-vertical="1"
        data-menu-dropdown-timeout="500"
        v-bind:class="asideMenuClass"
      >
        <!--        <img :src="asset(`media/aside-bg.png`)" class="sidebar-accent" />-->

        <div
          class="aside-title d-flex justify-content-between justify-center px-5"
          :style="{
            justifyContent: isArrowRight
              ? 'center !important'
              : 'space-between !important',
            padding: isArrowRight ? '0 !important' : '10px !important'
          }"
          style="height: 85px;"
        >
          <!--          <div-->
          <!--            class="position-relative shadow-lg d-flex align-items-center justify-content-center logo-wrapper"-->
          <!--            style="padding: 0px; width: 100px; height: 100px; border-radius: 100px; background-color: #EE2128"-->
          <!--          >-->
          <img
            style="width: 120px;"
            class="logo-jsc ml-4"
            :src="asset('media/awr-logo.png')"
          />
          <!--          </div>-->
          <img
            :src="asset('media/arrow.png')"
            class="arrow-icon"
            :class="{ arrowRight: isArrowRight }"
            :style="{
              backgroundColor: toggle ? '#0062E0' : ''
            }"
            @click="toggleMenu"
          />
        </div>
        <!-- example static menu here -->
        <perfect-scrollbar
          class="aside-menu scroll"
          style="height: calc(100vh - 140px); position: relative;"
        >
          <KTMenu
            :isShowTitle="isShowTitle"
            :isMouseEnter="isMouseEnter"
          ></KTMenu>
        </perfect-scrollbar>
      </div>
    </div>
  </div>
  <!-- end:: Aside -->
</template>

<style lang="scss" scoped>
.aside {
  -webkit-box-shadow: 14px 0px 22px 0px rgba(59, 116, 92, 0.04);
  -moz-box-shadow: 14px 0px 22px 0px rgba(59, 116, 92, 0.04);
  box-shadow: 14px 0px 22px 0px rgba(59, 116, 92, 0.04);
}

.arrowRight {
  transform: rotate(180deg);
}
.arrow-icon {
  width: 20px;
  //background-color: #fff;
  cursor: pointer;
  border-radius: 50%;
}
.arrow-icon:hover {
  background-color: rgb(86, 133, 225) !important;
}

.sidebar-accent {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 1;
}
.aside-title {
  position: relative;
  padding: 0px 0px 0px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9;

  .big-title {
    color: #061d52;
    line-height: 50px;
    font-size: 40px;
    font-style: normal;
    font-weight: bold;
  }
  .title {
    padding-left: 4px;
    color: #061d52;
    line-height: 19px;
    font-size: 16px;
    font-style: normal;
    font-weight: bold;
    opacity: 0.77;
  }
}
.copyright {
  background-color: #040720;
  font-size: 10px;
  padding: 12px 18px;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
}
</style>

<script>
import { mapGetters } from "vuex";
import { asset } from "@/core/utils";
// import KTBrand from "@/view/layout/brand/Brand.vue";

import KTLayoutAside from "@/assets/js/layout/base/aside.js";
import KTLayoutAsideMenu from "@/assets/js/layout/base/aside-menu.js";
import KTMenu from "@/view/layout/aside/Menu.vue";

export default {
  name: "KTAside",
  data() {
    return {
      insideTm: 0,
      outsideTm: 0,
      isShowTitle: true,
      toggle: false,
      isMouseEnter: false,
      isArrowRight: false
    };
  },
  components: {
    // KTBrand,
    KTMenu
  },
  mounted() {
    this.$nextTick(() => {
      // Init Aside
      KTLayoutAside.init(this.$refs["kt_aside"]);

      // Init Aside Menu
      KTLayoutAsideMenu.init(this.$refs["kt_aside_menu"]);
    });
  },
  methods: {
    asset,
    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     */
    // mouseEnter() {
    //   // check if the left aside menu is fixed
    //   if (document.body.classList.contains("aside-fixed")) {
    //     if (this.outsideTm) {
    //       clearTimeout(this.outsideTm);
    //       this.outsideTm = null;
    //     }
    //
    //     // if the left aside menu is minimized
    //     if (document.body.classList.contains("aside-minimize")) {
    //       document.body.classList.add("aside-minimize-hover");
    //
    //       // show the left aside menu
    //       document.body.classList.remove("aside-minimize");
    //     }
    //   }
    // },

    /**
     * Use for fixed left aside menu, to show menu on mouseenter event.
     */
    // mouseLeave() {
    //   if (document.body.classList.contains("aside-fixed")) {
    //     if (this.insideTm) {
    //       clearTimeout(this.insideTm);
    //       this.insideTm = null;
    //     }
    //
    //     // if the left aside menu is expand
    //     if (document.body.classList.contains("aside-minimize-hover")) {
    //       // hide back the left aside menu
    //       document.body.classList.remove("aside-minimize-hover");
    //       document.body.classList.add("aside-minimize");
    //     }
    //   }
    // },

    mouseEnter() {
      const menu = document.querySelector(".aside");
      const logo = document.querySelector(".logo-jsc");
      const wrapper = document.querySelector(".aside-fixed .wrapper");
      const header = document.querySelector(
        ".header-fixed.subheader-fixed .header "
      );
      const subHeader = document.querySelector(
        ".aside-enabled.subheader-fixed .subheader"
      );

      if (this.toggle) {
        this.isMouseEnter = true;
        const max = "265px";
        this.isShowTitle = true;
        menu.style.width = max;
        logo.style.display = "block";
        wrapper.style.paddingLeft = max;
        header.style.left = max;
        subHeader.style.left = max;
        this.isArrowRight = false;
      }
    },

    mouseLeave() {
      const menu = document.querySelector(".aside");
      const logo = document.querySelector(".logo-jsc");
      const wrapper = document.querySelector(".aside-fixed .wrapper");
      const header = document.querySelector(
        ".header-fixed.subheader-fixed .header "
      );
      const subHeader = document.querySelector(
        ".aside-enabled.subheader-fixed .subheader"
      );

      if (this.toggle) {
        this.isMouseEnter = false;
        const min = "70px";
        this.isShowTitle = false;
        menu.style.width = min;
        logo.style.display = "none";
        wrapper.style.paddingLeft = min;
        header.style.left = min;
        subHeader.style.left = min;
        this.isArrowRight = true;
      }
    },

    toggleMenu() {
      const menu = document.querySelector(".aside");
      const logo = document.querySelector(".logo-jsc");
      const wrapper = document.querySelector(".aside-fixed .wrapper");
      const header = document.querySelector(
        ".header-fixed.subheader-fixed .header "
      );
      const subHeader = document.querySelector(
        ".aside-enabled.subheader-fixed .subheader"
      );
      this.toggle = !this.toggle;
      const min = "70px";
      const max = "265px";

      if (this.toggle) {
        menu.style.width = min;
        logo.style.display = "none";
        wrapper.style.paddingLeft = min;
        header.style.left = min;
        subHeader.style.left = min;
        this.isShowTitle = false;
        this.isArrowRight = true;
      } else {
        menu.style.width = max;
        logo.style.display = "block";
        wrapper.style.paddingLeft = max;
        header.style.left = max;
        subHeader.style.left = max;
        this.isShowTitle = true;
        this.isArrowRight = false;
      }
    }
    // validateModule(menuItem) {
    //   const arrMenu = [];
    //   menuItem.forEach((m) => {
    //     if (m.submenu && m.submenu.length > 0) {
    //       const validatedSubmenu = this.validateModule(m.submenu);
    //       if (validatedSubmenu.length > 0) {
    //         m.submenu = validatedSubmenu;
    //         arrMenu.push(m);
    //       }
    //     } else {
    //       // validate

    //       const hasAccess = this.$store.getters.hasPermission(m.module, "view");
    //       if (hasAccess) {
    //         arrMenu.push(m);
    //       }
    //     }
    //   });

    //   return arrMenu;
    // },
    // refresh() {
    //   this.listMenuItem = this.validateModule(listMenu);
    // },
  },
  computed: {
    ...mapGetters(["layoutConfig", "getClasses"]),

    /**
     * Get extra classes for menu based on the options
     */
    asideMenuClass() {
      const classes = this.getClasses("aside_menu");
      if (typeof classes !== "undefined") {
        return classes.join(" ");
      }
      return null;
    }
  }
};
</script>
